module.exports = __webpack_public_path__ + "img/Transpordiamet_logo_valge_eng.becab168.svg";